import type { Reply } from 'models';
import { useMemo } from 'react';

type P = {
  comment?: Reply;
  contentObjectId: string;
};

export const useGetCommentParentId = ({ comment, contentObjectId }: P) =>
  useMemo(() => {
    if (!comment) {
      return contentObjectId;
    }

    return comment.parentId === contentObjectId ? comment.id : comment.parentId;
  }, [comment, contentObjectId]);
